import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class CheckboxAdapter extends TestAdapter {
  /**
   * Change the value of the component.
   * @param value {boolean | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: boolean | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    const label = await el.waitForElement(byCss('label'));
    const input = await label.waitForElement(byCss('input[type="checkbox"]'));
    const isChecked = (await input.getAttribute('aria-checked')) === 'true';

    const cVal = value ?? false;
    if (isChecked !== cVal) {
      await driver.click(label);
    }
  }

  /**
   * Clear the value of the component.
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }
}
